import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductRecipe, RecipesResponse } from 'src/app/models/recipe-response';
import { RecipeService } from 'src/app/services/recipe.service';

@Component({
  selector: 'app-recipes',
  templateUrl: './recipes.component.html',
  styleUrls: ['./recipes.component.scss']
})
export class RecipesComponent {
  productRecipes: RecipesResponse[] = [];
  filterWord: string = "";
  filterProductRecipes: RecipesResponse[] = [];
  selectedRecipe: number = null;
  edit = 0;
  showRecipe: { [key: number]: boolean } = {};
  expandedRows = new Set<number>();

  constructor(
    private recipeService: RecipeService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getRecipes();
  }

  getRecipes() {
    this.recipeService.getRecipes().subscribe({
      next: (response: any) => {
        this.productRecipes = response.data;
        this.filterProductRecipes = this.productRecipes;
      },
      error: (error) => {
        this.toastService.error("Error al cargar las recetas", "Error");
      }
    });
  }

  showIngredients(recipe: RecipesResponse) {
    if (!this.showRecipe[recipe.product.id])
      this.showRecipe[recipe.product.id] = true;
    else
      this.showRecipe[recipe.product.id] = !this.showRecipe[recipe.product.id];
  }

  toggleExpand(recipeId: number) {
    if (this.expandedRows.has(recipeId)) {
      this.expandedRows.delete(recipeId);
    } else {
      this.expandedRows.add(recipeId);
    }
  }

  isExpanded(recipeId: number): boolean {
    return this.expandedRows.has(recipeId);
  }

  filter() {
    this.filterProductRecipes = this.productRecipes.filter((r) => {
      return (r.product.code).toLowerCase().includes(this.filterWord.toLowerCase()) ||
      r.product.name.toLowerCase().includes(this.filterWord.toLowerCase());
    })
  }

  receiveDataSave(productRecipeIngredient: ProductRecipe) {
    for (let i = 0; i < this.productRecipes.length; i++) {
      if (this.productRecipes[i].product.id === productRecipeIngredient.productidcreated) {
        for (let j = 0; j < this.productRecipes[i].listIngredients.length; j++) {
          
          if (this.productRecipes[i].listIngredients[j].id === productRecipeIngredient.id) {
            this.productRecipes[i].listIngredients[j].quantity = productRecipeIngredient.quantity;
            break;
          }
        }
      } 
    }
    
    this.filterProductRecipes = this.productRecipes;
  }

  receiveDataDelete(data: [number, number]) {
    const recipeId = data[0];
    const ingredientId = data[1];
    this.productRecipes.forEach(recipe => {
      if (recipe.product.id === recipeId) {
        recipe.listIngredients = recipe.listIngredients.filter(ingredient => ingredient.id !== ingredientId);
      }
    });
    this.filterProductRecipes = this.productRecipes;
  }

  receiveDataAdd(productRecipeIngredient: ProductRecipe) {
    for (let i = 0; i < this.productRecipes.length; i++) {
      if (this.productRecipes[i].product.id === productRecipeIngredient.productidcreated) {
        this.productRecipes[i].listIngredients.push(productRecipeIngredient);
        break;
      } 
    }
    this.filterProductRecipes = this.productRecipes;
  }
}
